module.exports = __webpack_public_path__ + "img/solidworks.91ac7d89.jpeg";